import { FC, ReactElement } from 'react';
import styled from '@emotion/styled';
import TopBar from '../connected/TopBar';
import SideBar from '../connected/SideBar';

type Props = {
  children: ReactElement<any>;
  className?: string;
};

/**
 * SimpleLayoutの派生なので、SimpleLayoutにマージ希望
 */
const SimpleLayoutDraft: FC<Props> = ({ children, className }) => {
  return (
    <Root className={className}>
      <TopBar />
      <SideBar />
      <Content>{children}</Content>
    </Root>
  );
};

const Root = styled('div')(`
  height: 100%;
  padding-left: 302px;
  overflow-y: scroll;
  ::-webkit-scrollbar-track {
    background-color: #FFF;
  }
  ::-webkit-scrollbar {
    width: 4px;
    background-color: #EAEAEA;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #EAEAEA;
    border: none;
  }
`);

const Content = styled.main((props) => ({
  height: '100%',
  paddingTop: props.style ? props.style.paddingTop : undefined,
}));

export default SimpleLayoutDraft;
